const ArticleBlockPersonCardssetup = () => {
  const components = document.querySelectorAll('[data-component-article-block-faq]');
  components.forEach((component) => {
  });
};

ArticleBlockPersonCardssetup();